import { Box, H2, HStack, Text, VStack } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { Formik } from 'formik';

import { SecurityGroupAllocationFields } from './SecurityGroupAllocationFields';
import { CustomPortfolio, SecurityGroupAllocation } from './types';

const totalAllocationsPercent = (securityGroupAllocations: SecurityGroupAllocation[]) =>
  securityGroupAllocations.reduce((sum, allocation) => sum + Number(allocation.targetWeight), 0).toFixed(2);

export const CustomPortfolioBuilderForm = ({ customPortfolio }: { customPortfolio: CustomPortfolio }) => {
  const { securityGroupAllocations } = customPortfolio;
  return (
    <Formik initialValues={{ securityGroupAllocations }} onSubmit={() => {}}>
      {({ values }) => (
        <>
          <VStack css={{ gap: 'space.300', width: 'container.large', mdDown: { width: 'size.full' } }}>
            <H2 variant="title300">Holdings</H2>
            <Box>
              <SecurityGroupAllocationFields />
            </Box>
          </VStack>
          <Box
            css={{
              bg: 'background.surface',
              borderTop: '1px solid',
              borderTopColor: 'border.weak',
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
            }}
          >
            <HStack
              css={{
                alignItems: 'center',
                gap: 'space.50',
                margin: '0 auto',
                maxWidth: 'container.max',
                paddingY: 'space.300',
                paddingX: 'space.400',
              }}
            >
              <Text variant="text200" id="total-allocation-label">
                <strong>Total Allocation:</strong>
              </Text>
              <output aria-labelledby="total-allocation-label" className={css({ fontSize: 'fontSize.200' })}>
                {totalAllocationsPercent(values.securityGroupAllocations)}%
              </output>
            </HStack>
          </Box>
        </>
      )}
    </Formik>
  );
};
